export default "__VITE_ASSET__DYiD$Kb7__"